import { Color } from "@progress/kendo-drawing";

export const AlertDialog = {
  methods: {
    // 成功类型的弹出框
    showSuccess(text) {
      this.$swal({
        html: text,
        showCancelButton: false,
        confirmButtonText: text ? text : this.$t("lbl_EMPBE_Confirm")
      })
      this.$store.state.dirty = false;
    },
    //用户离开时提示框 保存前
    showLeavePage() {
      return new Promise((resolve, reject) => {
        this.$swal({
          text: this.$t("lbl_EMPBE_LeaveWithoutSaving"),
          showCancelButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          confirmButtonColor:"#7066e0",
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
          cancelButtonColor:"#6e7881",
        }).then(res => {
          resolve(res);
        })
      });
    },
    //用户离开时提示框 保存后
    showLeavePageAfterSave(title, text, ConfirmBtn) {
      return new Promise((resolve, reject) => {
        this.$swal({
          title: title,
          text: text,
          showDenyButton: true,
          denyButtonText: this.$t("lbl_EMPBE_ProductInfo_Discard"),
          showCancelButton: true,
          confirmButtonText: ConfirmBtn ?? this.$t("lbl_EMPBE_Ad_Save_Save"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
          customClass: "AlertDialog-SaveSucess AlertDialog-popup",
          reverseButtons: true,
        }).then(res => {
          resolve(res);
        })
      });
    },
    //提交成功提示框
    showSubmitSucess(title, text) {
      this.$swal({
        title: title,
        text: text,
        showCancelButton: false,
        confirmButtonText: this.$t("lbl_EMPBE_Ok"),
        customClass: "AlertDialog-SaveSucess",
      })
      this.$store.state.dirty = false;
    },
    // 保存成功提示框
    showSaveSucess(title, text) {
      return new Promise((resolve, reject) => {
        return this.$swal({
          title: title,
          text: text,
          confirmButtonText: this.$t("lbl_EMPBE_ProductInfo_SubmitNows"),
          cancelButtonText: this.$t("lbl_EMPBE_PIG_SubmitLater"),
          showCancelButton: true,
          customClass: "AlertDialog-SaveSucess",
          reverseButtons: true,
        }).then(res => {
          resolve(res);
        })
      });
    },
    showOnlyOkShow(title, text, confirmButton) {
      return new Promise((resolve, reject) => {
        return this.$swal({
          title: title,
          html: text,
          confirmButtonText: confirmButton,
          showCancelButton: false,
          customClass: "AlertDialog-SaveSucess",
          reverseButtons: true,
        }).then(res => {
          resolve(res);
        })
      });
    },
    // Delete / Delist 确认：Cancel 左，Confirm 右（Delete 红 / Delist 紫见 customClass）
    showConfirm(title, text, confirmButton, cancelButton, customClass) {
      return new Promise((resolve, reject) => {
        return this.$swal({
          title: title,
          text: text,
          confirmButtonText: confirmButton,
          cancelButtonText: cancelButton,
          showCancelButton: true,
          customClass: customClass || "AlertDialog-Delete",
          reverseButtons: true,
        }).then(res => {
          resolve(res);
        })
      });
    },
    confirmSwitchAdminMode(isCurrentlyApprovalMode) {
      const toEditMode = !!isCurrentlyApprovalMode;
      const titleKey = toEditMode
        ? 'lbl_EMPBE_SwitchToEditMode_ConfirmTitle'
        : 'lbl_EMPBE_SwitchToApprovalMode_ConfirmTitle';
      const bodyKey = toEditMode
        ? 'lbl_EMPBE_SwitchToEditMode_ConfirmBody'
        : 'lbl_EMPBE_SwitchToApprovalMode_ConfirmBody';
      // 与设计稿一致：左取消（白底灰字）、右确认（蓝底）；勿用 Delete 样式（确认红字、取消蓝底）
      return this.showCustomConfirmADD(
        this.$t(titleKey),
        this.$t(bodyKey),
        this.$t('lbl_HotSearches_Confirm'),
        this.$t('lbl_EMPBE_Cancel'),
      );
    },
    // （自定义提示框）
    showCustomConfirmADD(title, text, confirmButton, cancelButton) {
      return new Promise((resolve, reject) => {
        return this.$swal({
          title: title,
          text: text,
          confirmButtonText: confirmButton,
          cancelButtonText: cancelButton,
          showCancelButton: true,
          customClass: "AlertDialog-Add",
          reverseButtons: true,
        }).then(res => {
          resolve(res);
        })
      });
    },
    showCustomConfirmDEL(title, text, confirmButton, cancelButton) {
      return new Promise((resolve, reject) => {
        return this.$swal({
          title: title,
          text: text,
          confirmButtonText: confirmButton,
          cancelButtonText: cancelButton,
          showCancelButton: true,
          customClass: "AlertDialog-DEL",
          reverseButtons: true,
        }).then(res => {
          resolve(res);
        })
      });
    },
    ConfirmCustomHtml(title, html, confirmButton, cancelButton) {
       
      return new Promise((resolve, reject) => {
        this.$swal({
          title: title,
          html: html,
          showDenyButton: false, 
          showCancelButton: true,
          confirmButtonText: confirmButton,
          cancelButtonText: cancelButton,
          customClass: "AlertDialog-Delete-v2",
          reverseButtons: true,
        }).then(res => {
          resolve(res);
        })
      });
    },
    // （自定义提示框）
    showConfirm_Img(title, text, confirmButton, cancelButton, denyButton, imageUrl, imageWidth, imageHeight, className, isDisabledConfirm,confirm_Tlabel,cancel_Tlabel,deny_Tlabel,showDenyButton=true,showCancelButton=true,showConfirmButton=true,allowOutsideClick=true) {
      return new Promise((resolve, reject) => {
        return this.$swal.fire({
          imageUrl: imageUrl,
          imageWidth: imageWidth,
          imageHeight: imageHeight,
          title: title,
          html: text,
          showConfirmButton: showConfirmButton,
          confirmButtonText: confirmButton,
          cancelButtonText: cancelButton,
          showDenyButton: showDenyButton,
          denyButtonText: denyButton,
          showCancelButton: showCancelButton,
          customClass: className,
          reverseButtons: false,
          allowOutsideClick:allowOutsideClick,
          preConfirm: async () => {
            return isDisabledConfirm;
          },
          didOpen: (popup) => {
            const confirmBtn = popup.querySelector('.swal2-confirm');
            confirmBtn.setAttribute('t_label', confirm_Tlabel);
            const CancelBtn = popup.querySelector('.swal2-cancel');
            CancelBtn.setAttribute('t_label', cancel_Tlabel);
            const SalesLeadFreeQuota = popup.querySelector('.swal2-deny');
            SalesLeadFreeQuota.setAttribute('t_label', deny_Tlabel);
          },
        }).then(res => {
          resolve(res);
        })
      });
    },

  },
};